function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3693574,15.9799008 L3.10444696,4.71562113 C2.68604675,4.26609074 2.69941611,3.56733608 3.13263657,3.13261786 C3.56733069,2.69941883 4.26614565,2.6860499 4.7156904,3.10442916 L15.9806009,14.3687088 C16.3055181,14.6951007 16.4034449,15.1846695 16.2268858,15.6104625 C16.0503342,16.0362554 15.6349117,16.3136988 15.1749981,16.3136988 C14.8723112,16.3137102 14.5830013,16.1935379 14.3693574,15.9799008 Z",
  transform: "translate(9.556353, 9.556345) rotate(45.000000) translate(-9.556353, -9.556345) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.88581331,15.610461 C2.70926171,15.1846682 2.80718093,14.6950691 3.1320983,14.3687077 L14.3970169,3.1044331 C14.8465618,2.68604636 15.5453391,2.69941529 15.9800714,3.13262179 C16.4132844,3.56730192 16.4266538,4.26609439 16.008261,4.71562466 L4.7433424,15.9798992 C4.52969841,16.1935362 4.24039597,16.3137085 3.93772415,16.3137085 C3.47778757,16.3136971 3.06234971,16.0362652 2.88581331,15.610461 Z",
  transform: "translate(9.556349, 9.556349) rotate(45.000000) translate(-9.556349, -9.556349) "
}));

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.d3676882.svg";
export { ForwardRef as ReactComponent };